import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { isAuthenticated } from "../services/authStorage";
import Button from "./Button";
import { Container } from "./Layout";

const Shell = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
`;

const TopBar = styled.header`
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.background};
`;

const TopBarInner = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};
  padding-top: ${({ theme }) => theme.spacing(2)};
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  max-width: ${({ theme }) => theme.layout.maxWidth};
`;

const Brand = styled(NavLink)`
  font-size: ${({ theme }) => theme.typography.sizes.md};
  font-weight: ${({ theme }) => theme.typography.weights.medium};
  color: ${({ theme }) => theme.colors.text};
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.text};
  }
`;

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const NavItem = styled(NavLink)`
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
  border-radius: ${({ theme }) => theme.radii.control};
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.textMuted};
  text-decoration: none;
  transition:
    color ${({ theme }) => theme.transitions.default},
    background-color ${({ theme }) => theme.transitions.default};

  &:hover {
    color: ${({ theme }) => theme.colors.text};
    background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  }

  &.active {
    color: ${({ theme }) => theme.colors.accent};
  }
`;

const Main = styled.main`
  flex: 1;
  padding-top: ${({ theme }) => theme.spacing(5)};
  padding-bottom: ${({ theme }) => theme.spacing(6)};
`;

function PageShell({ children, narrow }) {
  const location = useLocation();
  const navigate = useNavigate();
  const authenticated = isAuthenticated();

  function handleDashboardButton() {
    if (isAuthenticated()) {
      navigate("/UserDashboard");
    } else {
      navigate("/SignIn");
    }
  }

  return (
    <Shell>
      <TopBar>
        <TopBarInner>
          <Brand to="/">yourdasa</Brand>
          <Nav>
            <NavItem to="/" end>
              Home
            </NavItem>
            <NavItem to="/LearnMore">Learn more</NavItem>
            <Button
              type="button"
              variant="secondary"
              onClick={handleDashboardButton}
            >
              Dashboard
            </Button>
            {authenticated && location.pathname === "/UserDashboard" && (
              <NavItem to="/DevPage">Dev tools</NavItem>
            )}
          </Nav>
        </TopBarInner>
      </TopBar>
      <Main>
        <Container $narrow={narrow}>{children}</Container>
      </Main>
    </Shell>
  );
}

export default PageShell;
